var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export function ProposalGeneralThinOutline(_a) {
    var color = _a.color, size = _a.size;
    return (_jsx("svg", __assign({ width: size, height: size, viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M9 44C8.2 44 7.5 43.7 6.9 43.1C6.3 42.5 6 41.8 6 41V31.1L12.75 23.65L14.9 25.8L9 32.25H39L33.45 25.95L35.6 23.8L42 31.1V41C42 41.8 41.7 42.5 41.1 43.1C40.5 43.7 39.8 44 39 44H9ZM9 41H39V35.25H9V41ZM22.1 28.75L14.15 20.8C13.5167 20.1667 13.2333 19.4584 13.3 18.675C13.3667 17.8917 13.7 17.2 14.3 16.6L24.9 6.00003C25.4645 5.44803 26.1639 5.16003 26.9984 5.13603C27.8328 5.11203 28.55 5.40003 29.15 6.00003L37.1 13.95C37.6667 14.5167 37.9583 15.1917 37.975 15.975C37.9917 16.7584 37.6667 17.4834 37 18.15L26.4 28.75C25.8333 29.3167 25.1333 29.6167 24.3 29.65C23.4667 29.6834 22.7333 29.3834 22.1 28.75ZM34.55 15.9L27.05 8.40003L16.65 18.8L24.15 26.3L34.55 15.9Z", fill: color }) })));
}
